import { createRoute } from '@tanstack/react-router';
import { EmailPage } from '@/features/growth/Email';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/growth/email',
  component: EmailPage,
});
